import * as React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export default function VirtualCatalogAddMenu(props: {
    entityLabel: 'team' | 'league' | 'player' | 'match';
    onAdd: () => void;
    onGenerateImmediately: () => void;
    onImportFromFile?: () => void;
    addLabel?: string;
    generateLabel?: string;
}) {
    const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
    const addLabel = props.addLabel ?? `Add ${props.entityLabel}`;
    const generateLabel = props.generateLabel ?? 'Generate immediately with AI';
    const closeAndRun = (action: () => void) => {
        setAnchor(null);
        action();
    };
    return (
        <>
            <Button variant="contained" endIcon={<ArrowDropDownIcon />} onClick={event => setAnchor(event.currentTarget)}>
                {addLabel}
            </Button>
            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
                <MenuItem onClick={() => closeAndRun(props.onAdd)}>{addLabel}</MenuItem>
                <MenuItem onClick={() => closeAndRun(props.onGenerateImmediately)}>
                    {generateLabel}
                </MenuItem>
                {props.onImportFromFile ? <MenuItem onClick={() => closeAndRun(props.onImportFromFile!)}>
                    Import from file
                </MenuItem> : null}
            </Menu>
        </>
    );
}
